module.exports = {"body":"<p>At Enhanced Interiors Remodeling we understand a bathroom is a highly utilized and\nfairly personal part of your home. We can create a space unique to your needs.\nCustom cabinetry can be built to fit in small and awkward areas. Perhaps a whirl pool\ntub with matching tub deck and shower is what you desire.</p>\n<p>However you like, Enhanced Interiors Remodeling will work for you.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./work/Bathrooms.md
// module id = 510
// module chunks = 0